import { captureException } from "@sentry/react";
import { useAtom } from "jotai";
import { useState } from "react";
import { toast } from "sonner";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { biometryEnabledState } from "web_myplann/Shared/State/appInfoAtom";
import { device } from "web_myplann/Utils/device";

export const useBiometryToggle = () => {
	const { t } = useResource();
	const [hasBiometry, setHasBiometry] = useAtom(biometryEnabledState);
	const [isPending, setIsPending] = useState(false);

	const toggle = async () => {
		if (isPending || !window.ReactNativeWebView) {
			return;
		}

		setIsPending(true);
		const nextHasBiometry = !hasBiometry;

		try {
			const { payload } = await device.changeBiometryStatus(nextHasBiometry);

			if (payload.success) {
				setHasBiometry(nextHasBiometry);
			} else {
				toast.error(payload.error ?? t(Resources.Security.BiometryError));
			}
		} catch (error) {
			captureException(error);
			toast.error(t(Resources.Security.BiometryError));
		} finally {
			setIsPending(false);
		}
	};

	return { hasBiometry, toggle, isPending };
};
